export { useProviderViewWaitingPatients } from './useProviderViewWaitingPatients';
